const HELP_TEXTS = {
  filters: {
    peerBrands:
      'Peer brands are automatically selected for recommendations if left blank. To override the automatic selection - please select a minimum of three brands.',
  },
  button: {
    calculate: 'Make sure to fill in the mandatory fields first.',
  },
};

export default HELP_TEXTS;
